import { createSlice } from '@reduxjs/toolkit'
import { setCurrentFilterInfo, setInitialFilterInfo } from '../../../actions'

/* AIRPORTS */
export const airportsFilter = createSlice({
  name: 'airportsFilter',
  initialState: [],
  reducers: {
    updateAirportsFiltersUI: (state, action) => {
      const { payload = [], meta = {}, entity } = action.payload
      const [airportCode, shouldAdd] = payload
      return state.map((airportObj, index) => {
        return {
          destinationAirports: airportObj.destinationAirports.map((airport) => {
            airport = { ...airport }
            if (meta.isNoneClick && entity === 'dest') {
              airport.checked = false
            } else if (meta.isAllClick && entity === 'dest') {
              airport.checked = true
            } else if (
              (meta.isOnlyClick && index === 0 && entity === 'dest') ||
              (meta.isOnlyClick && index === 1 && entity === 'origin')
            ) {
              airport.checked = airport.value === airportCode
            } else {
              airport.checked = airport.value === airportCode ? shouldAdd : airport.checked
            }

            return { ...airport }
          }),
          originAirports: airportObj.originAirports.map((airport) => {
            airport = { ...airport }
            if (meta.isNoneClick && entity === 'origin') {
              airport.checked = false
            } else if (meta.isAllClick && entity === 'origin') {
              airport.checked = true
            } else if (
              (meta.isOnlyClick && index === 0 && entity === 'origin') ||
              (meta.isOnlyClick && index === 1 && entity === 'dest')
            ) {
              airport.checked = airport.value === airportCode
            } else {
              airport.checked = airport.value === airportCode ? shouldAdd : airport.checked
            }
            return { ...airport }
          }),
        }
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setInitialFilterInfo, (state, action) => {
      const { payload = {} } = action.payload
      return payload?.AIRPORTS || { ...state }
    })
    builder.addCase(setCurrentFilterInfo, (state, action) => {
      const { payload = {} } = action
      return payload?.airportsFilter
    })
  },
})

export const { updateAirportsFiltersUI } = airportsFilter.actions
